import queryTenantConfigurationAndRoles from '@ms/yammer-graphql/dist/operations/queryTenantConfigurationAndRoles.graphql';

import { ManagedApiLifecycle, getGraphqlApiRequest, managedApiAction } from '../../api';
import { normalizeTenantConfigurationAndRoles } from '../../normalization/graphql/normalizeTenantConfigurationAndRoles';
import { TenantConfigurationAndRolesResponse } from '../../normalization/graphql/normalizeTenantConfigurationAndRoles.types';
import { RequestStatusType, tenantConfigurationAndRolesRequestId } from '../../state/types';
import { reportError } from '../../telemetry';
import { PromiseThunkAction } from '../../types';
import { getStatus as getRequestStatus } from '../requestStatuses/selectors';

import type {
  LoadTenantConfigurationAndRolesFulfilledAction,
  LoadTenantConfigurationAndRolesPendingAction,
  LoadTenantConfigurationAndRolesRejectedAction,
  ToggleSettingsTeachingBubble,
} from './actions.types';

export const toggleSettingsTeachingBubble = (show: boolean): ToggleSettingsTeachingBubble => ({
  type: 'ROLE_BASED_FRE.TOGGLE_SETTINGS_TEACHING_BUBBLE',
  payload: {
    show,
  },
});

const loadTenantConfigurationAndRolesFulfilled = (
  payload: LoadTenantConfigurationAndRolesFulfilledAction['payload']
): LoadTenantConfigurationAndRolesFulfilledAction => ({
  type: 'ROLE_BASED_FRE.LOAD_TENANT_CONFIGURATION_AND_ROLES_FULFILLED',
  payload,
});

const LoadTenantConfigurationAndRolesPendingAction = (): LoadTenantConfigurationAndRolesPendingAction => ({
  type: 'ROLE_BASED_FRE.LOAD_TENANT_CONFIGURATION_AND_ROLES_PENDING',
});

const LoadTenantConfigurationAndRolesRejectedAction = (
  error: unknown
): LoadTenantConfigurationAndRolesRejectedAction => ({
  type: 'ROLE_BASED_FRE.LOAD_TENANT_CONFIGURATION_AND_ROLES_REJECTED',
  payload: {
    error,
  },
  error: true,
});

const loadTenantConfigurationAndRolesRequest = () =>
  getGraphqlApiRequest({
    body: {
      operationName: 'TenantConfigurationAndRoles',
      query: queryTenantConfigurationAndRoles,
    },
  });

const loadStorylineDigestSettingsLifecycle: ManagedApiLifecycle<TenantConfigurationAndRolesResponse> = {
  pending: () => LoadTenantConfigurationAndRolesPendingAction(),
  fulfilled: (rawData) => {
    const normalizedData = normalizeTenantConfigurationAndRoles(rawData);

    return loadTenantConfigurationAndRolesFulfilled(normalizedData);
  },
  rejected: (error) => LoadTenantConfigurationAndRolesRejectedAction(error),
};

type Load = () => PromiseThunkAction<void>;
export const load: Load = () => async (dispatch, getState) => {
  const state = getState();
  const status = getRequestStatus(
    state,
    RequestStatusType.TenantConfigurationAndRoles,
    tenantConfigurationAndRolesRequestId
  );

  if (status !== 'notRequested') {
    return;
  }

  const action = managedApiAction({
    request: loadTenantConfigurationAndRolesRequest(),
    lifecycle: loadStorylineDigestSettingsLifecycle,
  });

  try {
    await dispatch(action);
  } catch (error) {
    reportError({ error });
  }
};
